var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { SourceType } from '@returnmates/client-core/src/constants/sourceType';
import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import * as actions from '../constants/actionTypes';
import callApi from '../graphql/callApi';
import { LabelType, PackageType, PaymentStatus, TripType, } from '../graphql/generated/api';
import * as selectors from '../selectors/partner';
import sagaFactory from '../utils/sagaFactory';
export function schedulePartnerPickup(_a) {
    var partner, uploadPackages, phoneNumber, partnerAttributes_1, paymentStatus, req, res, isFirstPackageMultiple, itemIndex, prevOrderId, i, packageQuantity, quantity, j, labelType, token, paymentIntent, clientSecret, makePaymentResp, paymentMethods, err_1, message;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
    var payload = _a.payload, next = _a.next;
    return __generator(this, function (_1) {
        switch (_1.label) {
            case 0:
                _1.trys.push([0, 22, , 24]);
                return [4 /*yield*/, select(selectors.getPartner)];
            case 1:
                partner = _1.sent();
                uploadPackages = ((_b = payload.uploadPackages) === null || _b === void 0 ? void 0 : _b.length)
                    ? payload.uploadPackages
                    : [
                        {
                            type: partner.isConsolidationEnabled ? LabelType.CONSOLIDATED : LabelType.PHYSICAL,
                            description: partner.packageDescription || '',
                        },
                    ];
                phoneNumber = payload.phone
                    .split('')
                    .filter(function (l) { return l >= '0' && l <= '9'; })
                    .join('');
                partnerAttributes_1 = payload.partnerData || {};
                if (payload.customAttributes) {
                    Object.keys(payload.customAttributes).forEach(function (key) {
                        partnerAttributes_1[key] = payload.customAttributes[key];
                    });
                }
                if (payload.timeSlot) {
                    partnerAttributes_1['Pickup Time'] = payload.timeSlot;
                }
                paymentStatus = payload.amount !== 0 ? PaymentStatus.UNPAID : PaymentStatus.FREE;
                req = {
                    partnerCode: payload.partner,
                    email: payload.email,
                    input: {
                        type: TripType.PICKUP,
                        date: payload.pickupDate,
                        name: payload.name,
                        phone: phoneNumber,
                        street: payload.street,
                        unit: payload.unit,
                        city: payload.city,
                        state: payload.state,
                        zipCode: payload.zipCode,
                        instructions: payload.instructions,
                        method: payload.method,
                        labelUrl: ((_c = uploadPackages === null || uploadPackages === void 0 ? void 0 : uploadPackages[0]) === null || _c === void 0 ? void 0 : _c.url) || undefined,
                        description: (_d = uploadPackages === null || uploadPackages === void 0 ? void 0 : uploadPackages[0]) === null || _d === void 0 ? void 0 : _d.description,
                        returnDestination: (uploadPackages === null || uploadPackages === void 0 ? void 0 : uploadPackages[0].returnDescription) || undefined,
                        packageAttributes: JSON.stringify(__assign(__assign(__assign({}, (_e = uploadPackages === null || uploadPackages === void 0 ? void 0 : uploadPackages[0]) === null || _e === void 0 ? void 0 : _e.attributes), partnerAttributes_1), { 'Item Number': (_g = (_f = payload.uploadPackages) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.itemNumber, 'Order Number': (_j = (_h = payload.uploadPackages) === null || _h === void 0 ? void 0 : _h[0]) === null || _j === void 0 ? void 0 : _j.orderNumber, qty: ((_k = payload === null || payload === void 0 ? void 0 : payload.uploadPackages) === null || _k === void 0 ? void 0 : _k.length)
                                ? "1 of ".concat(((_m = (_l = payload.uploadPackages) === null || _l === void 0 ? void 0 : _l[0]) === null || _m === void 0 ? void 0 : _m.orderQuantity) || 1)
                                : undefined, 'Return Reason': (_o = uploadPackages === null || uploadPackages === void 0 ? void 0 : uploadPackages[0]) === null || _o === void 0 ? void 0 : _o.returnReason })),
                        paymentStatus: paymentStatus,
                        source: SourceType.PLP,
                    },
                };
                return [4 /*yield*/, call(callApi.createPartnerTrip, req)];
            case 2:
                res = _1.sent();
                isFirstPackageMultiple = Boolean(((_p = uploadPackages === null || uploadPackages === void 0 ? void 0 : uploadPackages[0]) === null || _p === void 0 ? void 0 : _p.quantity) && ((_q = uploadPackages === null || uploadPackages === void 0 ? void 0 : uploadPackages[0]) === null || _q === void 0 ? void 0 : _q.quantity) > 1);
                if (!((_r = res.data) === null || _r === void 0 ? void 0 : _r.createPartnerTrip)) return [3 /*break*/, 20];
                itemIndex = 1;
                prevOrderId = (_s = uploadPackages[isFirstPackageMultiple ? 0 : 1]) === null || _s === void 0 ? void 0 : _s.orderId;
                i = isFirstPackageMultiple ? 0 : 1;
                _1.label = 3;
            case 3:
                if (!(i < ((uploadPackages === null || uploadPackages === void 0 ? void 0 : uploadPackages.length) || 0))) return [3 /*break*/, 8];
                if (!(uploadPackages === null || uploadPackages === void 0 ? void 0 : uploadPackages[i])) return [3 /*break*/, 7];
                packageQuantity = uploadPackages[i].quantity || 1;
                quantity = i === 0 ? packageQuantity - 1 : packageQuantity;
                if (prevOrderId !== uploadPackages[i].orderId) {
                    prevOrderId = uploadPackages[i].orderId || '';
                    itemIndex = 1;
                }
                else {
                    itemIndex += 1;
                }
                j = 0;
                _1.label = 4;
            case 4:
                if (!(j < quantity)) return [3 /*break*/, 7];
                labelType = LabelType.PHYSICAL;
                if (uploadPackages[i].url) {
                    labelType = LabelType.DIGITAL;
                }
                else if (partner.isConsolidationEnabled) {
                    labelType = LabelType.CONSOLIDATED;
                }
                return [4 /*yield*/, call(callApi.createPackage, {
                        input: {
                            tripId: res.data.createPartnerTrip.id,
                            labelType: labelType,
                            labelUrl: uploadPackages[i].url || undefined,
                            description: uploadPackages === null || uploadPackages === void 0 ? void 0 : uploadPackages[i].description,
                            retailerId: (_t = partner.retailer) === null || _t === void 0 ? void 0 : _t.id,
                            partnerCode: payload.partner,
                            paymentStatus: paymentStatus,
                            returnDestination: (uploadPackages === null || uploadPackages === void 0 ? void 0 : uploadPackages[i].returnDescription) || undefined,
                            source: SourceType.PLP,
                            partnerAttributes: JSON.stringify(__assign(__assign(__assign({}, (_u = uploadPackages === null || uploadPackages === void 0 ? void 0 : uploadPackages[i]) === null || _u === void 0 ? void 0 : _u.attributes), partnerAttributes_1), { 'Item Number': uploadPackages[i].itemNumber, 'Order Number': uploadPackages[i].orderNumber, qty: "".concat(itemIndex, " of ").concat(uploadPackages[i].orderQuantity || 1), 'Return Reason': (_v = uploadPackages === null || uploadPackages === void 0 ? void 0 : uploadPackages[i]) === null || _v === void 0 ? void 0 : _v.returnReason })),
                            date: res.data.createPartnerTrip.date,
                            type: PackageType.PICKUP,
                        },
                    })];
            case 5:
                _1.sent();
                _1.label = 6;
            case 6:
                j++;
                return [3 /*break*/, 4];
            case 7:
                i++;
                return [3 /*break*/, 3];
            case 8:
                token = {
                    name: payload.name,
                    email: payload.email,
                    phone: payload.phone,
                    street: payload.street,
                    unit: payload.unit,
                    city: payload.city,
                    state: payload.state,
                    zipCode: payload.zipCode,
                    instructions: payload.instructions,
                    method: payload.method,
                    paymentMethod: payload.paymentMethod,
                };
                if (!(payload.amount !== 0)) return [3 /*break*/, 16];
                return [4 /*yield*/, put({
                        type: actions.getPartnerPaymentIntent.type.REQUEST,
                        payload: {
                            amount: payload.amount,
                            email: payload.email,
                            partnerCode: partner.code,
                        },
                    })];
            case 9:
                _1.sent();
                return [4 /*yield*/, take([
                        actions.getPartnerPaymentIntent.type.SUCCESS,
                        actions.getPartnerPaymentIntent.type.FAILED,
                    ])];
            case 10:
                paymentIntent = _1.sent();
                if (!(paymentIntent.type === actions.getPartnerPaymentIntent.type.FAILED)) return [3 /*break*/, 12];
                return [4 /*yield*/, call(callApi.deleteTrip, { id: res.data.createPartnerTrip.id })];
            case 11:
                _1.sent();
                throw new Error(paymentIntent.payload);
            case 12:
                clientSecret = paymentIntent.payload.clientSecret;
                return [4 /*yield*/, put({
                        type: actions.makePayment.type.REQUEST,
                        payload: {
                            cardElement: payload.cardElement,
                            clientSecret: clientSecret,
                            paymentMethodId: (_w = payload.paymentMethod) === null || _w === void 0 ? void 0 : _w.id,
                        },
                    })];
            case 13:
                _1.sent();
                return [4 /*yield*/, take([
                        actions.makePayment.type.SUCCESS,
                        actions.makePayment.type.FAILED,
                    ])];
            case 14:
                makePaymentResp = _1.sent();
                if (!(makePaymentResp.type === actions.makePayment.type.FAILED)) return [3 /*break*/, 16];
                return [4 /*yield*/, call(callApi.deleteTrip, { id: res.data.createPartnerTrip.id })];
            case 15:
                _1.sent();
                throw new Error(makePaymentResp.payload);
            case 16: return [4 /*yield*/, call(callApi.confirmTrip, {
                    id: res.data.createPartnerTrip.id,
                    source: SourceType.PLP,
                })];
            case 17:
                _1.sent();
                return [4 /*yield*/, call(callApi.getPaymentMethodsByEmail, {
                        email: payload.email,
                    })];
            case 18:
                paymentMethods = _1.sent();
                if ((_y = (_x = paymentMethods.data) === null || _x === void 0 ? void 0 : _x.paymentMethodsByEmail) === null || _y === void 0 ? void 0 : _y[0]) {
                    token.paymentMethod = (_z = paymentMethods.data) === null || _z === void 0 ? void 0 : _z.paymentMethodsByEmail[0];
                }
                next({ token: token, partnerTripId: res.data.createPartnerTrip.id });
                return [4 /*yield*/, put({
                        type: actions.schedulePartnerPickup.type.SUCCESS,
                        payload: (_0 = res.data) === null || _0 === void 0 ? void 0 : _0.createPartnerTrip,
                    })];
            case 19:
                _1.sent();
                return [3 /*break*/, 21];
            case 20: throw new Error('Something went wrong, try again later');
            case 21: return [3 /*break*/, 24];
            case 22:
                err_1 = _1.sent();
                message = err_1.message;
                console.error('schedulePartnerPickup', err_1);
                next(false, message || 'Something went wrong, try again later');
                return [4 /*yield*/, put({
                        type: actions.schedulePartnerPickup.type.FAILED,
                    })];
            case 23:
                _1.sent();
                return [3 /*break*/, 24];
            case 24: return [2 /*return*/];
        }
    });
}
export function createAdditionalPartnerPackages(_a) {
    var trip, i, err_2, message;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var payload = _a.payload, next = _a.next;
    return __generator(this, function (_m) {
        switch (_m.label) {
            case 0:
                _m.trys.push([0, 7, , 9]);
                return [4 /*yield*/, call(callApi.getTrip, {
                        id: payload.tripId,
                    })];
            case 1:
                trip = _m.sent();
                i = 0;
                _m.label = 2;
            case 2:
                if (!(i < (((_b = payload.newPackages) === null || _b === void 0 ? void 0 : _b.length) || 0))) return [3 /*break*/, 5];
                return [4 /*yield*/, call(callApi.createPackage, {
                        input: {
                            tripId: payload.tripId,
                            labelType: (_c = payload.newPackages) === null || _c === void 0 ? void 0 : _c[i].type,
                            description: (_d = payload.newPackages) === null || _d === void 0 ? void 0 : _d[i].description,
                            labelUrl: ((_e = payload.newPackages) === null || _e === void 0 ? void 0 : _e[i].url) || undefined,
                            requiresBox: (_f = payload.newPackages) === null || _f === void 0 ? void 0 : _f[i].requiresBox,
                            isSwap: (_g = payload.newPackages) === null || _g === void 0 ? void 0 : _g[i].isSwap,
                            paymentStatus: PaymentStatus.UNPAID,
                            source: ((_j = (_h = payload.newPackages) === null || _h === void 0 ? void 0 : _h[i]) === null || _j === void 0 ? void 0 : _j.source) || null,
                            date: '',
                            type: PackageType[((_l = (_k = trip === null || trip === void 0 ? void 0 : trip.data) === null || _k === void 0 ? void 0 : _k.trip) === null || _l === void 0 ? void 0 : _l.type) || PackageType.DROPOFF],
                        },
                    })];
            case 3:
                _m.sent();
                _m.label = 4;
            case 4:
                i++;
                return [3 /*break*/, 2];
            case 5:
                next(true);
                return [4 /*yield*/, put({
                        type: actions.createAdditionalPartnerPackages.type.SUCCESS,
                    })];
            case 6:
                _m.sent();
                return [3 /*break*/, 9];
            case 7:
                err_2 = _m.sent();
                message = err_2.message;
                console.error('createAdditionalPartnerPacks', err_2);
                next(false, message || 'Something went wrong, try aging later');
                return [4 /*yield*/, put({
                        type: actions.createAdditionalPartnerPackages.type.FAILED,
                    })];
            case 8:
                _m.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
export var getPartner = sagaFactory('getPartner', actions.getPartner, callApi.getPartner, 'partner');
export var getDeliveriesByPhone = sagaFactory('getDeliveriesByPhone', actions.getDeliveriesByPhone, callApi.getDeliveriesByPhone, 'deliveriesByPhone');
export var addPartnerContact = sagaFactory('addPartnerContact', actions.addPartnerContact, callApi.addPartnerContact, 'savePartnerContact');
export var getReturnReasons = sagaFactory('getReturnReasons', actions.getReturnReasons, callApi.getReturnReasons, 'returnReasons');
export function createPartnerDestination(_a) {
    var res, err_3, message;
    var _b, _c, _d;
    var payload = _a.payload, next = _a.next;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _e.trys.push([0, 4, , 6]);
                return [4 /*yield*/, call(callApi.createPartnerDestination, {
                        partnerCode: payload.partnerCode,
                        addressId: payload.addressId,
                    })];
            case 1:
                res = _e.sent();
                if (!((_b = res.data) === null || _b === void 0 ? void 0 : _b.createPartnerDestination)) return [3 /*break*/, 3];
                return [4 /*yield*/, put({
                        type: actions.createPartnerDestination.type.SUCCESS,
                        payload: {
                            destination: (_c = res.data) === null || _c === void 0 ? void 0 : _c.createPartnerDestination,
                            partnerCode: payload.partnerCode,
                        },
                    })];
            case 2:
                _e.sent();
                next === null || next === void 0 ? void 0 : next((_d = res.data) === null || _d === void 0 ? void 0 : _d.createPartnerDestination);
                _e.label = 3;
            case 3: return [3 /*break*/, 6];
            case 4:
                err_3 = _e.sent();
                message = err_3.message;
                console.error('createPartnerDestination', message);
                next === null || next === void 0 ? void 0 : next(false, message || 'Something went wrong, try aging later');
                return [4 /*yield*/, put({
                        type: actions.createPartnerDestination.type.FAILED,
                    })];
            case 5:
                _e.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function partnerSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(actions.schedulePartnerPickup.type.REQUEST, schedulePartnerPickup)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getPartner.type.REQUEST, getPartner)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getDeliveriesByPhone.type.REQUEST, getDeliveriesByPhone)];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.addPartnerContact.type.REQUEST, addPartnerContact)];
            case 4:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.createAdditionalPartnerPackages.type.REQUEST, createAdditionalPartnerPackages)];
            case 5:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getReturnReasons.type.REQUEST, getReturnReasons)];
            case 6:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.createPartnerDestination.type.REQUEST, createPartnerDestination)];
            case 7:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default partnerSaga;
//# sourceMappingURL=partner.js.map